import { Lock, MapPin, Repeat, XCircle } from "lucide-react";
import { formatEventRange } from "../utils/eventDomain";

// Title, date and time, Series row, location, host and notes of what an
// Event detail shows — an occurrence's effective values (effectiveOccurrence)
// or an Event at its own dates. Shared by EventFocusModal's series detail and
// OccurrenceOnlyDetail (mirrors iOS EventDetailHeaderSections).
//   hostedBy     null hides the row (an occurrence without its creator)
//   dateFootnote under the date ("From when this event repeated")
//   seriesLabel  the Series row ("Repeats weekly"); null hides it
export default function EventDetailHeader({ details, hostedBy, dateFootnote = null, seriesLabel = null }) {
  return (
    <>
      <div className="flex items-baseline gap-2 mb-1">
        <h2 className={`text-lg font-bold ${details.isCanceled ? "line-through text-gray-500" : ""}`}>
          {details.title}
        </h2>
        {details.is_private && (
          <span
            className="flex shrink-0 items-center gap-0.5 text-xs text-gray-500"
            title="Private events appear as Busy on shared calendars."
          >
            <Lock size={12} aria-hidden="true" />
            Private
          </span>
        )}
      </div>
      {details.isCanceled && (
        <p className="flex items-center gap-1 text-sm font-semibold text-red-600 mb-1">
          <XCircle size={14} aria-hidden="true" />
          Canceled
        </p>
      )}
      {hostedBy && <p className="text-sm text-gray-500 mb-3">Hosted by {hostedBy}</p>}

      <div className="text-sm text-gray-700 space-y-1 mb-3">
        <p>{formatEventRange(details.starts_at, details.ends_at, details.is_all_day, details.timezone)}</p>
        {seriesLabel && (
          <p className="flex items-center gap-1 text-gray-500">
            <Repeat size={14} aria-hidden="true" />
            <span className="sr-only">Series: </span>
            {seriesLabel}
          </p>
        )}
        {dateFootnote && <p className="text-xs text-gray-500">{dateFootnote}</p>}
        {details.location && (
          <p className="flex items-center gap-1 text-gray-500">
            <MapPin size={14} />
            {details.location}
          </p>
        )}
      </div>

      {details.description && (
        <p className="text-sm text-gray-800 whitespace-pre-wrap mb-4">{details.description}</p>
      )}
    </>
  );
}
